import {
    
    GET_SHOP_LIST,
    GET_SHOP_LIST_SUCCESS,
  } from "../../actions/shop/types";
  
  const initialState = {
    
    shopsLoading:false,
    shops:[],
    count:0,
    
  };
  
  
  
  export const shops = (state = initialState, action)=> {
    const { type, payload } = action;
    switch (type) {
  
      case GET_SHOP_LIST:
          
        return {
          ...state,
          shopsLoading: true,
        };
      case GET_SHOP_LIST_SUCCESS:
      
        return {
          ...state,
          shopsLoading:false,
          shops: payload.results,
          count:payload.count
        };
  
     
        default: {
          return state;
        }
    }
  }
  